import { Editor } from 'slate'

export function withImages(editor: Editor, options: any = {}) {
  return editor
}
